import NextImage from '@allesauto/core/nextImage';
import { FieldTypeAsset, FieldTypeLink } from '@allesauto/utils/*';
import { pushAnalyticsEvent } from '@allesauto/utils/analytics';
import { getUrlFromStoryblokLink } from '@allesauto/utils/funcs';
import clsx from 'clsx';
import { useRouter } from 'next/router';

enum ShowColor {
  IMMEDIATELY = 'IMMEDIATELY',
  ON_HOVER = 'ON_HOVER',
}

export interface ImageLogoItemProps {
  text?: string;
  text2?: string;
  image?: FieldTypeAsset;
  link?: FieldTypeLink;
  showColor: ShowColor;
  track: boolean;
  _uid: string;
  component: string;
}

const cssClasses = {
  container: clsx(
    'max-w-[250px] sm:min-h-[150px] sm:min-w-[150px] sm:px-[15px] md:h-[250px] md:min-w-[250px] md:px-[30px]',
    'bg-white border-[2px] border-white duration-200 ease-in-out flex flex-col items-center justify-start sm:gap-[8px] md:gap-[15px] hover:border-red60'
  ),
  text: 'text-grey40 text-center font-weight-bold',
  imageContainer:
    'sm:max-h-[90px] sm:pb-[10px] sm:h-full md:max-h-[180px] md:pb-[15px] border-b-1px border-b-grey40 w-full duration-200 ease-in-out',
  colorOnHover: 'grayscale-[1] hover:grayscale-[0]',
};

const ImageLogoItem = (props: ImageLogoItemProps) => {
  const {
    text,
    text2,
    image,
    link: storyblokLink,
    showColor = ShowColor.IMMEDIATELY,
    track,
  } = props;
  const router = useRouter();

  const link = storyblokLink ? getUrlFromStoryblokLink(storyblokLink) : '';

  const onClick = () => {
    if (link) {
      if (track) {
        pushAnalyticsEvent({
          event: 'slider_item_logo_item_click',
          text: text,
          url: link,
        });
      }

      router.push(link);
    }
  };

  return (
    <button
      role="button"
      disabled={!link}
      aria-disabled={!link}
      onClick={onClick}
      className={cssClasses.container}
    >
      {image?.filename && (
        <NextImage
          className={clsx(
            cssClasses.imageContainer,
            showColor == ShowColor.ON_HOVER && cssClasses.colorOnHover
          )}
          layout="fill"
          src={image?.filename}
          alt={image?.alt || ''}
          objectPosition="center"
          objectFit="contain"
          imgClassName="!static aspect-square"
        />
      )}
      <div>
        {text && <p className={cssClasses.text}>{text}</p>}
        {text2 && <p className={cssClasses.text}>{text2}</p>}
      </div>
    </button>
  );
};

export default ImageLogoItem;
